function initMap() {

    // create global infoWindow objects
    infoWindow = new google.maps.InfoWindow({
        maxWidth: 300,
    });

    // dataTable: contain the rows related to one LatLng at a time
    // var rows_subset;

    // latLng + water_sample_date identifies a row uniquely, which will be stored in 'row_to-display'
    var row_to_display;

    var mapDefaultZoomLevel = 9; 
    var HR_county_center = { lat: 46.624692, lng: 25.579358 };

    // draw the map
    map = new google.maps.Map(document.getElementById('map'), {
        zoom: mapDefaultZoomLevel,
        center: HR_county_center,
    });

    var HR_county_coordinates = [
        {lat: 47.1758232116699, lng: 25.4290943145751},
        {lat: 47.1715393066406, lng: 25.4269981384278},
        {lat: 47.1664047241212, lng: 25.4342002868653},
        {lat: 47.1628952026367, lng: 25.4382781982422},
        {lat: 47.160572052002, lng: 25.4418258666992},
        {lat: 47.1576690673829, lng: 25.4441795349122},
        {lat: 47.1553382873536, lng: 25.4469051361085},
        {lat: 47.1536293029786, lng: 25.4512386322022},
        {lat: 47.1497192382814, lng: 25.454475402832},
        {lat: 47.1457328796387, lng: 25.4582672119141},
        {lat: 47.1436500549317, lng: 25.4647674560547},
        {lat: 47.1409721374512, lng: 25.4700469970703},
        {lat: 47.1394500732422, lng: 25.4735355377197},
        {lat: 47.1338768005371, lng: 25.4798088073731},
        {lat: 47.1340408325196, lng: 25.4840259552001},
        {lat: 47.1321105957032, lng: 25.487466812134},
        {lat: 47.1300926208497, lng: 25.4915924072267},
        {lat: 47.1289825439453, lng: 25.4948482513428},
        {lat: 47.1277236938477, lng: 25.4980754852295},
        {lat: 47.1250534057618, lng: 25.4992294311523},
        {lat: 47.1218070983887, lng: 25.5022239685059},
        {lat: 47.118320465088, lng: 25.5067844390869},
        {lat: 47.1176223754883, lng: 25.5119724273682},
        {lat: 47.1175842285157, lng: 25.521677017212},
        {lat: 47.1133003234864, lng: 25.5286502838134},
        {lat: 47.1042976379395, lng: 25.5288410186767},
        {lat: 47.1003952026367, lng: 25.5289707183838},
        {lat: 47.0926399230957, lng: 25.5338649749757},
        {lat: 47.0852584838868, lng: 25.5348110198976},
        {lat: 47.0822715759278, lng: 25.5465602874758},
        {lat: 47.0826530456544, lng: 25.5579242706299},
        {lat: 47.0840339660644, lng: 25.5655097961425},
        {lat: 47.0846977233887, lng: 25.5767421722413},
        {lat: 47.0821189880371, lng: 25.5861015319825},
        {lat: 47.0795745849609, lng: 25.5945701599121},
        {lat: 47.0777778625488, lng: 25.6019172668458},
        {lat: 47.0808181762696, lng: 25.6078662872314},
        {lat: 47.0835266113282, lng: 25.6137714385986},
        {lat: 47.0878868103027, lng: 25.6191158294679},
        {lat: 47.093532562256, lng: 25.622564315796},
        {lat: 47.0949211120605, lng: 25.6308631896973},
        {lat: 47.0935363769531, lng: 25.6399841308595},
        {lat: 47.0912055969239, lng: 25.6477375030518},
        {lat: 47.0885162353515, lng: 25.6571254730226},
        {lat: 47.0895805358887, lng: 25.6650390625},
        {lat: 47.0890884399413, lng: 25.6732482910156},
        {lat: 47.0899658203126, lng: 25.6786994934083},
        {lat: 47.0861396789551, lng: 25.6839179992677},
        {lat: 47.0848007202149, lng: 25.693391799927},
        {lat: 47.0826530456544, lng: 25.6979274749755},
        {lat: 47.0797767639161, lng: 25.705753326416},
        {lat: 47.0804634094238, lng: 25.7101516723634},
        {lat: 47.0763893127443, lng: 25.7163238525391},
        {lat: 47.0767250061036, lng: 25.7224597930908},
        {lat: 47.0744857788087, lng: 25.7311992645264},
        {lat: 47.0728187561035, lng: 25.7370738983154},
        {lat: 47.064510345459, lng: 25.7428474426271},
        {lat: 47.0584449768068, lng: 25.7451324462891},
        {lat: 47.0537910461426, lng: 25.7441005706789},
        {lat: 47.0492286682129, lng: 25.7484188079837},
        {lat: 47.0448913574219, lng: 25.7550544738771},
        {lat: 47.0417213439941, lng: 25.7619380950928},
        {lat: 47.0386657714844, lng: 25.7669696807862},
        {lat: 47.0317497253419, lng: 25.7710819244384},
        {lat: 47.0293006896973, lng: 25.7738761901856},
        {lat: 47.0256156921388, lng: 25.7746677398683},
        {lat: 47.021297454834, lng: 25.7713184356689},
        {lat: 47.0176925659181, lng: 25.7708034515383},
        {lat: 47.0124092102051, lng: 25.7748889923095},
        {lat: 47.0081634521486, lng: 25.782814025879},
        {lat: 47.0024719238282, lng: 25.7866878509521},
        {lat: 46.9992790222169, lng: 25.789644241333},
        {lat: 46.9946136474611, lng: 25.7922515869141},
        {lat: 46.9909820556641, lng: 25.7923202514649},
        {lat: 46.9847373962403, lng: 25.7933273315431},
        {lat: 46.981430053711, lng: 25.7932472229003},
        {lat: 46.9782562255861, lng: 25.7954998016358},
        {lat: 46.973747253418, lng: 25.798486709595},
        {lat: 46.9677314758301, lng: 25.8031387329102},
        {lat: 46.9656524658204, lng: 25.8080558776856},
        {lat: 46.968849182129, lng: 25.8117179870607},
        {lat: 46.972812652588, lng: 25.815118789673},
        {lat: 46.9758071899414, lng: 25.8188571929932},
        {lat: 46.9753684997559, lng: 25.8237609863282},
        {lat: 46.9737854003907, lng: 25.8277053833008},
        {lat: 46.9718894958496, lng: 25.8310146331788},
        {lat: 46.9694747924806, lng: 25.8320827484131},
        {lat: 46.9655075073242, lng: 25.8337306976318},
        {lat: 46.9637756347656, lng: 25.8377819061279},
        {lat: 46.9628868103028, lng: 25.8403949737549},
        {lat: 46.9604034423828, lng: 25.8411655426026},
        {lat: 46.958221435547, lng: 25.8418331146241},
        {lat: 46.9541778564454, lng: 25.8422183990478},
        {lat: 46.9515495300294, lng: 25.8435745239258},
        {lat: 46.9483375549317, lng: 25.8426246643068},
        {lat: 46.9458351135254, lng: 25.8434906005861},
        {lat: 46.9439010620118, lng: 25.8443336486818},
        {lat: 46.9393386840821, lng: 25.8476886749268},
        {lat: 46.9375114440919, lng: 25.8503684997559},
        {lat: 46.9318389892579, lng: 25.8529548645019},
        {lat: 46.9283142089844, lng: 25.8544464111328},
        {lat: 46.924171447754, lng: 25.8588905334473},
        {lat: 46.9219932556153, lng: 25.8594055175781},
        {lat: 46.921226501465, lng: 25.8476963043216},
        {lat: 46.9222068786622, lng: 25.8424720764162},
        {lat: 46.9235534667969, lng: 25.8368377685546},
        {lat: 46.9233665466309, lng: 25.8300189971923},
        {lat: 46.9239006042481, lng: 25.8242740631105},
        {lat: 46.9259834289551, lng: 25.8184032440186},
        {lat: 46.9275169372559, lng: 25.8120384216309},
        {lat: 46.9281845092774, lng: 25.8058490753174},
        {lat: 46.9245185852052, lng: 25.8021678924561},
        {lat: 46.9149742126465, lng: 25.8019847869874},
        {lat: 46.90922164917, lng: 25.7957363128663},
        {lat: 46.9021759033203, lng: 25.7856884002686},
        {lat: 46.8983535766601, lng: 25.7800960540773},
        {lat: 46.8937759399413, lng: 25.7776412963868},
        {lat: 46.8898086547852, lng: 25.7714481353761},
        {lat: 46.8843460083008, lng: 25.7657661437989},
        {lat: 46.8780632019043, lng: 25.7717227935793},
        {lat: 46.8728981018066, lng: 25.775806427002},
        {lat: 46.8699913024903, lng: 25.7788944244384},
        {lat: 46.864658355713, lng: 25.7811031341554},
        {lat: 46.8595962524415, lng: 25.7806262969972},
        {lat: 46.8547897338868, lng: 25.7776050567627},
        {lat: 46.8514823913575, lng: 25.7744979858398},
        {lat: 46.8482475280763, lng: 25.7665271759033},
        {lat: 46.8447113037111, lng: 25.7638072967532},
        {lat: 46.8377571105958, lng: 25.7691459655762},
        {lat: 46.8350601196289, lng: 25.7750511169434},
        {lat: 46.8350296020507, lng: 25.7811222076417},
        {lat: 46.8403320312501, lng: 25.7832870483398},
        {lat: 46.8430480957031, lng: 25.7837791442871},
        {lat: 46.8453025817872, lng: 25.7803955078125},
        {lat: 46.8497009277345, lng: 25.7813129425049},
        {lat: 46.8511581420899, lng: 25.7857418060305},
        {lat: 46.8495063781739, lng: 25.7912902832031},
        {lat: 46.8447113037111, lng: 25.7997055053711},
        {lat: 46.8418426513673, lng: 25.8049964904786},
        {lat: 46.8333320617676, lng: 25.795467376709},
        {lat: 46.8266677856445, lng: 25.8036632537842},
        {lat: 46.8233032226563, lng: 25.8131008148194},
        {lat: 46.8251075744629, lng: 25.8184890747071},
        {lat: 46.8231086730956, lng: 25.8220520019532},
        {lat: 46.8187904357911, lng: 25.8312492370605},
        {lat: 46.8187522888184, lng: 25.8361568450931},
        {lat: 46.8149299621582, lng: 25.8388233184814},
        {lat: 46.8080101013185, lng: 25.8340969085694},
        {lat: 46.8027267456055, lng: 25.8240413665771},
        {lat: 46.8027877807617, lng: 25.8193321228028},
        {lat: 46.8012886047364, lng: 25.8113708496094},
        {lat: 46.7954139709474, lng: 25.8081436157227},
        {lat: 46.7909126281738, lng: 25.8123359680177},
        {lat: 46.7839126586913, lng: 25.8154773712159},
        {lat: 46.7777328491212, lng: 25.819040298462},
        {lat: 46.7664680480957, lng: 25.8165760040284},
        {lat: 46.7611656188965, lng: 25.8143615722656},
        {lat: 46.7548408508301, lng: 25.8160457611084},
        {lat: 46.7485961914064, lng: 25.8159046173095},
        {lat: 46.7437400817872, lng: 25.8088226318359},
        {lat: 46.739902496338, lng: 25.802806854248},
        {lat: 46.7353630065917, lng: 25.8073234558107},
        {lat: 46.7314300537111, lng: 25.8054122924805},
        {lat: 46.728801727295, lng: 25.7999038696291},
        {lat: 46.7257881164552, lng: 25.7925205230713},
        {lat: 46.7238273620606, lng: 25.788465499878},
        {lat: 46.7194213867189, lng: 25.7908039093018},
        {lat: 46.7160835266114, lng: 25.7937564849855},
        {lat: 46.7139396667481, lng: 25.7951488494876},
        {lat: 46.7136917114259, lng: 25.8005390167237},
        {lat: 46.709011077881, lng: 25.7965354919434},
        {lat: 46.7051391601562, lng: 25.7985363006592},
        {lat: 46.7044525146485, lng: 25.8043727874758},
        {lat: 46.7024421691895, lng: 25.8089466094971},
        {lat: 46.6975555419922, lng: 25.8153839111329},
        {lat: 46.6945266723633, lng: 25.8197593688964},
        {lat: 46.6874771118165, lng: 25.8287296295166},
        {lat: 46.6828575134278, lng: 25.8355541229249},
        {lat: 46.6778907775879, lng: 25.8376045227051},
        {lat: 46.6721763610841, lng: 25.8433380126953},
        {lat: 46.6682090759278, lng: 25.8492984771729},
        {lat: 46.6648750305176, lng: 25.8548450469971},
        {lat: 46.6593284606934, lng: 25.8627109527588},
        {lat: 46.6525230407715, lng: 25.8659553527832},
        {lat: 46.6500434875489, lng: 25.8703231811524},
        {lat: 46.6510772705079, lng: 25.8758811950684},
        {lat: 46.6508255004883, lng: 25.8794059753421},
        {lat: 46.6491394042969, lng: 25.8841781616211},
        {lat: 46.6491699218751, lng: 25.8923912048341},
        {lat: 46.6490211486816, lng: 25.8994083404542},
        {lat: 46.6512832641602, lng: 25.9057140350344},
        {lat: 46.6573143005372, lng: 25.9099483489991},
        {lat: 46.66121673584, lng: 25.9067268371583},
        {lat: 46.666660308838, lng: 25.9050579071046},
        {lat: 46.6723670959474, lng: 25.9001350402834},
        {lat: 46.6755905151367, lng: 25.8968601226807},
        {lat: 46.6809425354004, lng: 25.8917675018311},
        {lat: 46.686580657959, lng: 25.8872985839844},
        {lat: 46.6915702819825, lng: 25.8882751464847},
        {lat: 46.697608947754, lng: 25.8921794891358},
        {lat: 46.6996879577638, lng: 25.8971481323242},
        {lat: 46.6957397460939, lng: 25.8995761871341},
        {lat: 46.696403503418, lng: 25.9065685272218},
        {lat: 46.7015571594239, lng: 25.9098472595215},
        {lat: 46.7021484375, lng: 25.9248123168945},
        {lat: 46.7007522583007, lng: 25.930124282837},
        {lat: 46.7024612426757, lng: 25.9365367889404},
        {lat: 46.6992645263672, lng: 25.9474563598632},
        {lat: 46.6951751708986, lng: 25.9530620574952},
        {lat: 46.697177886963, lng: 25.9679794311524},
        {lat: 46.6969184875489, lng: 25.9772300720215},
        {lat: 46.691780090332, lng: 25.9777297973636},
        {lat: 46.6889495849609, lng: 25.9795017242433},
        {lat: 46.6862335205079, lng: 25.9835071563722},
        {lat: 46.6798286437989, lng: 25.9857349395753},
        {lat: 46.6756057739258, lng: 25.9922676086426},
        {lat: 46.6703224182128, lng: 25.9975776672363},
        {lat: 46.6666030883788, lng: 26.001237869263},
        {lat: 46.6634750366212, lng: 26.0020942687989},
        {lat: 46.6610221862793, lng: 26.0067825317382},
        {lat: 46.6574897766114, lng: 26.0080814361573},
        {lat: 46.6548919677735, lng: 26.0100936889651},
        {lat: 46.6504592895508, lng: 26.0080585479737},
        {lat: 46.6408195495605, lng: 26.0168323516846},
        {lat: 46.634262084961, lng: 26.0189247131348},
        {lat: 46.634635925293, lng: 26.0125980377197},
        {lat: 46.6377830505372, lng: 26.0051937103273},
        {lat: 46.6327590942383, lng: 26.0056724548343},
        {lat: 46.6252937316896, lng: 26.0016384124756},
        {lat: 46.6245727539063, lng: 25.9974975585938},
        {lat: 46.6211128234863, lng: 25.9934368133545},
        {lat: 46.6127433776855, lng: 25.996364593506},
        {lat: 46.6065177917481, lng: 25.9981765747071},
        {lat: 46.6011657714845, lng: 26.0006217956543},
        {lat: 46.5970840454102, lng: 26.0050048828128},
        {lat: 46.5928306579591, lng: 26.0127353668212},
        {lat: 46.5893020629884, lng: 26.0179557800293},
        {lat: 46.5857391357421, lng: 26.0240325927735},
        {lat: 46.5792350769044, lng: 26.0273590087892},
        {lat: 46.571315765381, lng: 26.0347518920899},
        {lat: 46.5637435913087, lng: 26.0338001251221},
        {lat: 46.5579719543458, lng: 26.0354042053223},
        {lat: 46.5548820495607, lng: 26.0397338867189},
        {lat: 46.5504684448242, lng: 26.0420742034912},
        {lat: 46.5460472106934, lng: 26.0371246337891},
        {lat: 46.5404167175294, lng: 26.0420360565186},
        {lat: 46.5371856689454, lng: 26.0457401275634},
        {lat: 46.5323143005372, lng: 26.0496158599854},
        {lat: 46.52982711792, lng: 26.0575599670411},
        {lat: 46.5261993408204, lng: 26.0646686553955},
        {lat: 46.5259704589844, lng: 26.0742492675782},
        {lat: 46.5229835510254, lng: 26.0764751434327},
        {lat: 46.5173950195314, lng: 26.0823402404786},
        {lat: 46.51273727417, lng: 26.0845241546632},
        {lat: 46.5030517578126, lng: 26.0817852020264},
        {lat: 46.4912185668946, lng: 26.0781555175781},
        {lat: 46.4878234863282, lng: 26.0654907226564},
        {lat: 46.4889106750489, lng: 26.064832687378},
        {lat: 46.4926910400391, lng: 26.062442779541},
        {lat: 46.4947814941406, lng: 26.0586318969728},
        {lat: 46.4926910400391, lng: 26.0496749877931},
        {lat: 46.4914855957032, lng: 26.0333251953125},
        {lat: 46.4927368164063, lng: 26.0204372406007},
        {lat: 46.4870300292969, lng: 26.0146598815919},
        {lat: 46.4821968078614, lng: 26.0082092285157},
        {lat: 46.4789199829101, lng: 26.0144290924073},
        {lat: 46.4732131958008, lng: 26.0182743072509},
        {lat: 46.4694786071777, lng: 26.0131607055665},
        {lat: 46.4654693603516, lng: 26.0164699554445},
        {lat: 46.4594726562499, lng: 26.013771057129},
        {lat: 46.4576034545898, lng: 26.0088768005372},
        {lat: 46.4509239196778, lng: 26.0062103271484},
        {lat: 46.4453849792481, lng: 26.006908416748},
        {lat: 46.4432449340821, lng: 26.0026264190673},
        {lat: 46.4418678283691, lng: 25.9964942932129},
        {lat: 46.4386863708497, lng: 25.9891948699953},
        {lat: 46.43510055542, lng: 25.9909439086913},
        {lat: 46.4332809448243, lng: 25.9952468872071},
        {lat: 46.4304008483887, lng: 26.0001373291016},
        {lat: 46.4272613525391, lng: 26.0038528442383},
        {lat: 46.4229621887207, lng: 26.0034160614014},
        {lat: 46.4182434082032, lng: 25.9983196258546},
        {lat: 46.4114990234376, lng: 26.0004749298099},
        {lat: 46.4070129394531, lng: 25.9968223571777},
        {lat: 46.4065399169922, lng: 26.0030517578126},
        {lat: 46.4085006713868, lng: 26.0051956176761},
        {lat: 46.4121284484863, lng: 26.0089378356935},
        {lat: 46.4115371704103, lng: 26.0151844024659},
        {lat: 46.4093666076661, lng: 26.0215206146241},
        {lat: 46.4158477783203, lng: 26.0235996246339},
        {lat: 46.4122085571289, lng: 26.0298175811768},
        {lat: 46.4141235351562, lng: 26.034086227417},
        {lat: 46.4172439575196, lng: 26.0362071990967},
        {lat: 46.4164848327637, lng: 26.0450630187988},
        {lat: 46.4152793884278, lng: 26.052682876587},
        {lat: 46.4120864868165, lng: 26.0634613037109},
        {lat: 46.4075393676759, lng: 26.0610446929932},
        {lat: 46.4027709960939, lng: 26.0596961975099},
        {lat: 46.4010047912597, lng: 26.0633735656738},
        {lat: 46.4010314941407, lng: 26.0700607299806},
        {lat: 46.4003601074219, lng: 26.0771884918214},
        {lat: 46.399730682373, lng: 26.0862426757813},
        {lat: 46.4007034301759, lng: 26.0941181182862},
        {lat: 46.401725769043, lng: 26.1011657714845},
        {lat: 46.4008903503419, lng: 26.1076774597169},
        {lat: 46.3997192382814, lng: 26.112298965454},
        {lat: 46.3978996276857, lng: 26.1198539733887},
        {lat: 46.3977699279785, lng: 26.1250267028809},
        {lat: 46.3971977233886, lng: 26.134735107422},
        {lat: 46.3937759399415, lng: 26.139337539673},
        {lat: 46.3916473388672, lng: 26.1472816467285},
        {lat: 46.3890953063965, lng: 26.1508464813233},
        {lat: 46.3875045776368, lng: 26.1583995819092},
        {lat: 46.3860969543458, lng: 26.1623210906984},
        {lat: 46.3851470947266, lng: 26.1664810180664},
        {lat: 46.3816184997559, lng: 26.164400100708},
        {lat: 46.3755760192872, lng: 26.1657714843751},
        {lat: 46.3711166381837, lng: 26.166654586792},
        {lat: 46.3675727844239, lng: 26.1686286926271},
        {lat: 46.3622398376466, lng: 26.1653461456299},
        {lat: 46.3556175231933, lng: 26.1679344177247},
        {lat: 46.3525009155273, lng: 26.1665534973145},
        {lat: 46.3477973937988, lng: 26.1656818389894},
        {lat: 46.3440284729004, lng: 26.1629028320313},
        {lat: 46.3405570983887, lng: 26.1579055786133},
        {lat: 46.3355178833008, lng: 26.1544055938722},
        {lat: 46.3315086364747, lng: 26.152235031128},
        {lat: 46.3272552490236, lng: 26.150707244873},
        {lat: 46.3204345703125, lng: 26.153902053833},
        {lat: 46.3180541992188, lng: 26.1555519104004},
        {lat: 46.315372467041, lng: 26.1579952239992},
        {lat: 46.3166313171387, lng: 26.1648845672607},
        {lat: 46.3150596618653, lng: 26.1708488464358},
        {lat: 46.3135681152344, lng: 26.1760902404785},
        {lat: 46.3109893798829, lng: 26.1809883117677},
        {lat: 46.3118324279786, lng: 26.189868927002},
        {lat: 46.310775756836, lng: 26.1940231323245},
        {lat: 46.3117103576661, lng: 26.199354171753},
        {lat: 46.3126716613771, lng: 26.2039051055908},
        {lat: 46.3121719360353, lng: 26.2111568450929},
        {lat: 46.3151435852052, lng: 26.2172470092774},
        {lat: 46.3162307739257, lng: 26.2234058380128},
        {lat: 46.3185539245607, lng: 26.2278232574463},
        {lat: 46.3230323791504, lng: 26.2309169769289},
        {lat: 46.3252601623536, lng: 26.2320518493653},
        {lat: 46.3283729553223, lng: 26.2335453033448},
        {lat: 46.3328742980958, lng: 26.2352619171143},
        {lat: 46.3358917236328, lng: 26.2428188323976},
        {lat: 46.3390846252441, lng: 26.2451438903809},
        {lat: 46.3400192260743, lng: 26.2491931915286},
        {lat: 46.3418540954591, lng: 26.2559814453126},
        {lat: 46.3426895141603, lng: 26.262353897095},
        {lat: 46.3439826965331, lng: 26.270170211792},
        {lat: 46.3444519042968, lng: 26.274185180664},
        {lat: 46.3423271179199, lng: 26.278507232666},
        {lat: 46.3385658264161, lng: 26.2833786010742},
        {lat: 46.3371238708496, lng: 26.2906284332277},
        {lat: 46.3318367004395, lng: 26.2945232391359},
        {lat: 46.329002380371, lng: 26.2913398742676},
        {lat: 46.3244132995606, lng: 26.2899894714355},
        {lat: 46.3214645385743, lng: 26.2851600646972},
        {lat: 46.313632965088, lng: 26.2825736999512},
        {lat: 46.3070182800293, lng: 26.2822799682618},
        {lat: 46.3027839660644, lng: 26.2801952362062},
        {lat: 46.2987899780274, lng: 26.2786617279056},
        {lat: 46.2968139648438, lng: 26.2737751007081},
        {lat: 46.2922286987305, lng: 26.2728023529052},
        {lat: 46.290382385254, lng: 26.2758655548096},
        {lat: 46.2875556945801, lng: 26.271879196167},
        {lat: 46.2823333740234, lng: 26.266098022461},
        {lat: 46.2801475524902, lng: 26.2640705108645},
        {lat: 46.2782173156738, lng: 26.2559108734131},
        {lat: 46.2729949951172, lng: 26.2548103332521},
        {lat: 46.2701110839844, lng: 26.2563953399659},
        {lat: 46.2671279907227, lng: 26.2548236846924},
        {lat: 46.2646408081055, lng: 26.2596969604492},
        {lat: 46.2603149414064, lng: 26.2602558135989},
        {lat: 46.2565498352051, lng: 26.2663497924806},
        {lat: 46.2533340454102, lng: 26.2612285614014},
        {lat: 46.2496337890626, lng: 26.2630062103272},
        {lat: 46.2469825744629, lng: 26.2645282745361},
        {lat: 46.2408638000489, lng: 26.2640628814698},
        {lat: 46.2389259338379, lng: 26.2603988647464},
        {lat: 46.2373161315919, lng: 26.2546844482423},
        {lat: 46.2353897094727, lng: 26.2551574707031},
        {lat: 46.232048034668, lng: 26.2584533691407},
        {lat: 46.2283515930177, lng: 26.2581996917725},
        {lat: 46.2247161865234, lng: 26.2579784393311},
        {lat: 46.2238731384277, lng: 26.2589015960693},
        {lat: 46.2197303771973, lng: 26.2600364685059},
        {lat: 46.2168197631837, lng: 26.2619209289551},
        {lat: 46.2155189514161, lng: 26.2592678070068},
        {lat: 46.2126541137695, lng: 26.2558345794677},
        {lat: 46.2109565734864, lng: 26.2541885375977},
        {lat: 46.2101554870606, lng: 26.249719619751},
        {lat: 46.2062721252441, lng: 26.2208938598633},
        {lat: 46.2044639587403, lng: 26.2206039428713},
        {lat: 46.2025718688965, lng: 26.2183818817139},
        {lat: 46.200710296631, lng: 26.21875},
        {lat: 46.1969413757324, lng: 26.2178745269776},
        {lat: 46.1946144104005, lng: 26.2178211212158},
        {lat: 46.1929244995118, lng: 26.2165145874024},
        {lat: 46.1891326904297, lng: 26.2149219512939},
        {lat: 46.1864852905275, lng: 26.2130165100099},
        {lat: 46.1830406188965, lng: 26.2115001678467},
        {lat: 46.1802520751953, lng: 26.2096195220947},
        {lat: 46.1798362731934, lng: 26.2036170959473},
        {lat: 46.1821212768556, lng: 26.1956806182861},
        {lat: 46.183807373047, lng: 26.1880741119385},
        {lat: 46.1791114807129, lng: 26.1890125274658},
        {lat: 46.178379058838, lng: 26.178783416748},
        {lat: 46.1708106994629, lng: 26.1779136657716},
        {lat: 46.1659660339357, lng: 26.176223754883},
        {lat: 46.1605834960937, lng: 26.1742744445801},
        {lat: 46.1623611450195, lng: 26.1634101867679},
        {lat: 46.1661758422852, lng: 26.1527252197266},
        {lat: 46.1693038940431, lng: 26.142469406128},
        {lat: 46.1718940734864, lng: 26.1373367309571},
        {lat: 46.1716194152832, lng: 26.131525039673},
        {lat: 46.1695137023926, lng: 26.1251468658447},
        {lat: 46.1659469604492, lng: 26.1242771148683},
        {lat: 46.1627006530762, lng: 26.1196517944337},
        {lat: 46.1612625122071, lng: 26.1178493499756},
        {lat: 46.1624221801758, lng: 26.1122570037842},
        {lat: 46.164463043213, lng: 26.1024913787844},
        {lat: 46.1655387878419, lng: 26.0978355407716},
        {lat: 46.1636085510254, lng: 26.0904197692871},
        {lat: 46.1600875854493, lng: 26.0867805480958},
        {lat: 46.1577873229982, lng: 26.0891151428223},
        {lat: 46.1576728820801, lng: 26.0866069793702},
        {lat: 46.1581687927247, lng: 26.0835208892822},
        {lat: 46.1586112976074, lng: 26.0804557800294},
        {lat: 46.1591186523438, lng: 26.0760383605958},
        {lat: 46.1601333618165, lng: 26.071912765503},
        {lat: 46.1606178283692, lng: 26.0686359405519},
        {lat: 46.1603546142579, lng: 26.0654907226564},
        {lat: 46.1600875854493, lng: 26.0608482360839},
        {lat: 46.1595993041993, lng: 26.0575656890869},
        {lat: 46.1554603576661, lng: 26.0513172149658},
        {lat: 46.1525001525879, lng: 26.0443077087402},
        {lat: 46.1501884460449, lng: 26.0387630462648},
        {lat: 46.1460037231446, lng: 26.037603378296},
        {lat: 46.1430816650391, lng: 26.0352954864502},
        {lat: 46.1435203552246, lng: 26.0316047668458},
        {lat: 46.1364173889161, lng: 26.0264720916749},
        {lat: 46.1325721740723, lng: 26.0240573883057},
        {lat: 46.1302070617676, lng: 26.0219268798829},
        {lat: 46.1281661987304, lng: 26.0207042694092},
        {lat: 46.1306381225585, lng: 26.0084972381592},
        {lat: 46.1289329528809, lng: 26.0010643005372},
        {lat: 46.1263275146485, lng: 25.9958953857423},
        {lat: 46.1260643005372, lng: 25.9907302856446},
        {lat: 46.1287231445314, lng: 25.98508644104},
        {lat: 46.1340522766114, lng: 25.9841842651368},
        {lat: 46.1350975036622, lng: 25.9783706665041},
        {lat: 46.133113861084, lng: 25.9739494323733},
        {lat: 46.131175994873, lng: 25.9671726226807},
        {lat: 46.1308937072755, lng: 25.957410812378},
        {lat: 46.1283760070801, lng: 25.9457302093506},
        {lat: 46.1275825500489, lng: 25.9407787322998},
        {lat: 46.1288604736329, lng: 25.9348487854006},
        {lat: 46.1304969787599, lng: 25.9256191253663},
        {lat: 46.1300086975098, lng: 25.9153251647949},
        {lat: 46.1255416870117, lng: 25.9092559814456},
        {lat: 46.124454498291, lng: 25.8990783691406},
        {lat: 46.1215705871583, lng: 25.8927669525147},
        {lat: 46.1239318847657, lng: 25.8800868988037},
        {lat: 46.1234436035156, lng: 25.8744640350342},
        {lat: 46.1214408874512, lng: 25.8706817626954},
        {lat: 46.1195449829103, lng: 25.8623332977296},
        {lat: 46.1203689575195, lng: 25.8581027984619},
        {lat: 46.1238403320312, lng: 25.8544616699219},
        {lat: 46.124382019043, lng: 25.8489284515381},
        {lat: 46.1287803649903, lng: 25.8487205505372},
        {lat: 46.1329154968262, lng: 25.843168258667},
        {lat: 46.1363792419434, lng: 25.839153289795},
        {lat: 46.1429252624513, lng: 25.8381690979004},
        {lat: 46.146812438965, lng: 25.8321018218995},
        {lat: 46.1496734619142, lng: 25.8251285552981},
        {lat: 46.1541481018068, lng: 25.8232288360596},
        {lat: 46.1587944030762, lng: 25.8178958892823},
        {lat: 46.1617584228516, lng: 25.815637588501},
        {lat: 46.1649169921876, lng: 25.8109321594241},
        {lat: 46.1669387817383, lng: 25.8061542510987},
        {lat: 46.1699409484864, lng: 25.8054351806643},
        {lat: 46.1745338439942, lng: 25.8001728057862},
        {lat: 46.1767501831056, lng: 25.7928295135499},
        {lat: 46.1835517883302, lng: 25.7905979156494},
        {lat: 46.1903648376465, lng: 25.7950344085693},
        {lat: 46.1951789855958, lng: 25.7900428771973},
        {lat: 46.200481414795, lng: 25.7856349945069},
        {lat: 46.204174041748, lng: 25.7802257537842},
        {lat: 46.2074394226074, lng: 25.7765274047853},
        {lat: 46.2103843688965, lng: 25.7709140777588},
        {lat: 46.213794708252, lng: 25.7663269042969},
        {lat: 46.216682434082, lng: 25.7667751312257},
        {lat: 46.2190589904785, lng: 25.7630939483643},
        {lat: 46.2396659851074, lng: 25.7467975616458},
        {lat: 46.2423477172852, lng: 25.7452411651612},
        {lat: 46.2444915771486, lng: 25.7387924194335},
        {lat: 46.2467765808106, lng: 25.7386169433595},
        {lat: 46.250114440918, lng: 25.7292022705081},
        {lat: 46.2580108642579, lng: 25.7339439392092},
        {lat: 46.2635955810547, lng: 25.7357501983644},
        {lat: 46.2692031860352, lng: 25.7322692871095},
        {lat: 46.2738151550293, lng: 25.7273483276367},
        {lat: 46.2772407531738, lng: 25.7179832458498},
        {lat: 46.2761116027832, lng: 25.7091312408447},
        {lat: 46.274658203125, lng: 25.6951866149903},
        {lat: 46.2726974487306, lng: 25.6856918334962},
        {lat: 46.270004272461, lng: 25.6778240203858},
        {lat: 46.2677841186523, lng: 25.6770839691165},
        {lat: 46.2618331909181, lng: 25.6732959747314},
        {lat: 46.2575683593751, lng: 25.6664619445801},
        {lat: 46.2542190551759, lng: 25.6557273864746},
        {lat: 46.2497253417969, lng: 25.6442623138428},
        {lat: 46.2466850280763, lng: 25.6329898834228},
        {lat: 46.2420082092286, lng: 25.6221065521241},
        {lat: 46.2397384643554, lng: 25.6123180389404},
        {lat: 46.2399978637695, lng: 25.6020908355712},
        {lat: 46.2365455627443, lng: 25.5988903045655},
        {lat: 46.2340812683107, lng: 25.5942840576172},
        {lat: 46.2272949218751, lng: 25.590389251709},
        {lat: 46.2187156677246, lng: 25.5819091796876},
        {lat: 46.2143821716309, lng: 25.5738964080813},
        {lat: 46.2182655334474, lng: 25.5645198822022},
        {lat: 46.2163276672364, lng: 25.561674118042},
        {lat: 46.21342086792, lng: 25.5611667633057},
        {lat: 46.2080612182618, lng: 25.5578746795657},
        {lat: 46.208812713623, lng: 25.5527572631837},
        {lat: 46.2096290588379, lng: 25.548469543457},
        {lat: 46.20560836792, lng: 25.5425510406495},
        {lat: 46.2013244628907, lng: 25.5378284454346},
        {lat: 46.1959266662599, lng: 25.5256519317627},
        {lat: 46.1884422302247, lng: 25.5116043090821},
        {lat: 46.1823196411134, lng: 25.5094661712648},
        {lat: 46.1762886047364, lng: 25.5102138519288},
        {lat: 46.1737632751465, lng: 25.5088844299316},
        {lat: 46.1684303283692, lng: 25.5079746246338},
        {lat: 46.1627807617188, lng: 25.50883102417},
        {lat: 46.1590576171874, lng: 25.5078010559083},
        {lat: 46.1558876037599, lng: 25.5027770996094},
        {lat: 46.1511383056641, lng: 25.5012912750245},
        {lat: 46.1496810913087, lng: 25.4994125366212},
        {lat: 46.1484375, lng: 25.4963264465332},
        {lat: 46.1486473083497, lng: 25.492261886597},
        {lat: 46.1470146179199, lng: 25.4852161407471},
        {lat: 46.1422996520997, lng: 25.4801177978517},
        {lat: 46.1362915039063, lng: 25.482439041138},
        {lat: 46.1335029602051, lng: 25.4790897369385},
        {lat: 46.1299438476562, lng: 25.4793529510497},
        {lat: 46.1249237060546, lng: 25.4796466827394},
        {lat: 46.1220092773439, lng: 25.4761657714845},
        {lat: 46.1197586059571, lng: 25.474193572998},
        {lat: 46.1169242858887, lng: 25.4723148345948},
        {lat: 46.1118507385253, lng: 25.4693088531495},
        {lat: 46.107967376709, lng: 25.4681987762452},
        {lat: 46.105052947998, lng: 25.4649810791016},
        {lat: 46.1025085449219, lng: 25.4628009796144},
        {lat: 46.1041564941406, lng: 25.4528026580812},
        {lat: 46.1073684692382, lng: 25.4548625946045},
        {lat: 46.1125259399413, lng: 25.4554138183594},
        {lat: 46.1164321899415, lng: 25.4534034729004},
        {lat: 46.1202507019042, lng: 25.4559326171874},
        {lat: 46.1249923706055, lng: 25.4511833190919},
        {lat: 46.1234169006348, lng: 25.4463195800782},
        {lat: 46.1244163513185, lng: 25.4386157989503},
        {lat: 46.1228141784669, lng: 25.4362087249757},
        {lat: 46.1229782104493, lng: 25.4324989318848},
        {lat: 46.1231269836426, lng: 25.4299564361573},
        {lat: 46.1234855651855, lng: 25.4265117645263},
        {lat: 46.1249427795411, lng: 25.4210891723633},
        {lat: 46.126564025879, lng: 25.4151916503909},
        {lat: 46.124050140381, lng: 25.4086780548095},
        {lat: 46.1309738159181, lng: 25.4104099273683},
        {lat: 46.1327667236328, lng: 25.4065837860108},
        {lat: 46.1334877014161, lng: 25.4011421203613},
        {lat: 46.130672454834, lng: 25.3958110809326},
        {lat: 46.1358642578126, lng: 25.386417388916},
        {lat: 46.1358947753907, lng: 25.3749904632569},
        {lat: 46.14213180542, lng: 25.3659400939942},
        {lat: 46.152084350586, lng: 25.3594131469728},
        {lat: 46.1587715148925, lng: 25.3515167236329},
        {lat: 46.1625862121581, lng: 25.3497791290283},
        {lat: 46.1675949096681, lng: 25.3450412750244},
        {lat: 46.1710739135742, lng: 25.3393669128418},
        {lat: 46.17631149292, lng: 25.3344364166261},
        {lat: 46.1786613464355, lng: 25.3314151763917},
        {lat: 46.1767730712892, lng: 25.3275966644289},
        {lat: 46.1753807067871, lng: 25.3238124847413},
        {lat: 46.1738281250001, lng: 25.3218593597412},
        {lat: 46.1766395568848, lng: 25.3172359466554},
        {lat: 46.1776237487794, lng: 25.3135318756104},
        {lat: 46.1761589050293, lng: 25.3086986541748},
        {lat: 46.177001953125, lng: 25.2970943450928},
        {lat: 46.1737098693848, lng: 25.2862091064453},
        {lat: 46.1708793640137, lng: 25.273983001709},
        {lat: 46.1734275817872, lng: 25.2687416076662},
        {lat: 46.1787567138672, lng: 25.2691898345948},
        {lat: 46.184009552002, lng: 25.271873474121},
        {lat: 46.184757232666, lng: 25.2745952606202},
        {lat: 46.1871871948243, lng: 25.2745819091797},
        {lat: 46.1890182495117, lng: 25.2714805603028},
        {lat: 46.1898956298829, lng: 25.2642097473145},
        {lat: 46.1864624023438, lng: 25.2602119445801},
        {lat: 46.1816139221193, lng: 25.2590770721436},
        {lat: 46.1748008728027, lng: 25.2567157745361},
        {lat: 46.1680412292481, lng: 25.2662830352784},
        {lat: 46.1621360778809, lng: 25.2640419006348},
        {lat: 46.1580390930176, lng: 25.26167678833},
        {lat: 46.1546745300294, lng: 25.2616348266602},
        {lat: 46.1454811096191, lng: 25.2572174072266},
        {lat: 46.1417465209961, lng: 25.2491722106934},
        {lat: 46.1446151733398, lng: 25.2406501770021},
        {lat: 46.1467132568359, lng: 25.2309741973877},
        {lat: 46.1512947082521, lng: 25.2269248962403},
        {lat: 46.1550292968751, lng: 25.2185287475586},
        {lat: 46.1564674377443, lng: 25.2148189544678},
        {lat: 46.1615447998046, lng: 25.2058029174805},
        {lat: 46.1645317077637, lng: 25.2009162902833},
        {lat: 46.1689567565919, lng: 25.1948356628419},
        {lat: 46.1694946289064, lng: 25.1882152557374},
        {lat: 46.1657142639161, lng: 25.1837100982667},
        {lat: 46.1680526733398, lng: 25.1736450195312},
        {lat: 46.1705131530762, lng: 25.1668987274171},
        {lat: 46.1747436523438, lng: 25.1574554443359},
        {lat: 46.1781005859376, lng: 25.1524715423584},
        {lat: 46.1789321899414, lng: 25.150053024292},
        {lat: 46.1805648803712, lng: 25.1418285369874},
        {lat: 46.185791015625, lng: 25.1352024078369},
        {lat: 46.1966857910156, lng: 25.1240329742432},
        {lat: 46.2040061950684, lng: 25.1182346343994},
        {lat: 46.2127723693848, lng: 25.1132984161377},
        {lat: 46.2202606201173, lng: 25.1093711853028},
        {lat: 46.2262840270997, lng: 25.1073436737061},
        {lat: 46.2307662963868, lng: 25.1079177856448},
        {lat: 46.2325210571289, lng: 25.1047821044923},
        {lat: 46.2318382263184, lng: 25.0951423645021},
        {lat: 46.2335319519044, lng: 25.0873756408691},
        {lat: 46.2324943542481, lng: 25.0809020996095},
        {lat: 46.2367782592774, lng: 25.0774936676026},
        {lat: 46.2408790588379, lng: 25.0789279937744},
        {lat: 46.2430839538574, lng: 25.0748291015626},
        {lat: 46.2451133728028, lng: 25.0679130554199},
        {lat: 46.2450942993164, lng: 25.062475204468},
        {lat: 46.2457466125488, lng: 25.056173324585},
        {lat: 46.2433319091798, lng: 25.0481986999513},
        {lat: 46.241065979004, lng: 25.0449142456056},
        {lat: 46.2406845092775, lng: 25.0385990142825},
        {lat: 46.2427864074708, lng: 25.0343837738037},
        {lat: 46.2436828613282, lng: 25.0292053222659},
        {lat: 46.243450164795, lng: 25.027286529541},
        {lat: 46.2454376220704, lng: 25.024227142334},
        {lat: 46.2464218139648, lng: 25.0196228027344},
        {lat: 46.2474136352539, lng: 25.0159168243409},
        {lat: 46.2484512329102, lng: 25.0119972229003},
        {lat: 46.2439689636231, lng: 25.00199508667},
        {lat: 46.2449340820312, lng: 24.9938697814943},
        {lat: 46.2405662536622, lng: 24.9918327331543},
        {lat: 46.2379531860352, lng: 24.9894676208497},
        {lat: 46.239040374756, lng: 24.9852142333986},
        {lat: 46.2414817810059, lng: 24.9814891815187},
        {lat: 46.2429161071777, lng: 24.9773674011231},
        {lat: 46.244987487793, lng: 24.9607257843018},
        {lat: 46.2467002868652, lng: 24.96067237854},
        {lat: 46.2487754821778, lng: 24.9638366699218},
        {lat: 46.2497100830078, lng: 24.957805633545},
        {lat: 46.2465400695801, lng: 24.9583053588867},
        {lat: 46.2470359802247, lng: 24.9549713134766},
        {lat: 46.2470626831055, lng: 24.9491329193115},
        {lat: 46.2478485107422, lng: 24.9465789794922},
        {lat: 46.2455787658691, lng: 24.9476051330569},
        {lat: 46.2433471679689, lng: 24.9485187530518},
        {lat: 46.2450485229493, lng: 24.9446754455566},
        {lat: 46.2479171752931, lng: 24.9449348449709},
        {lat: 46.249282836914, lng: 24.9438171386718},
        {lat: 46.2490158081055, lng: 24.9394779205322},
        {lat: 46.2466316223145, lng: 24.9344024658204},
        {lat: 46.2550163269044, lng: 24.9406623840331},
        {lat: 46.260383605957, lng: 24.9353027343752},
        {lat: 46.2641868591309, lng: 24.9313220977783},
        {lat: 46.2659492492677, lng: 24.9354419708253},
        {lat: 46.2690238952636, lng: 24.9318275451661},
        {lat: 46.2728462219238, lng: 24.928581237793},
        {lat: 46.2757225036621, lng: 24.9218788146973},
        {lat: 46.2785530090331, lng: 24.9161167144776},
        {lat: 46.2810440063477, lng: 24.9117240905762},
        {lat: 46.2839469909668, lng: 24.9056911468508},
        {lat: 46.2871170043946, lng: 24.9022941589357},
        {lat: 46.2921867370606, lng: 24.8983402252197},
        {lat: 46.2942352294923, lng: 24.8949623107912},
        {lat: 46.2989654541016, lng: 24.8898067474365},
        {lat: 46.2989311218263, lng: 24.8855075836183},
        {lat: 46.300521850586, lng: 24.8815612792969},
        {lat: 46.3005256652832, lng: 24.8797473907472},
        {lat: 46.3027153015137, lng: 24.8756198883057},
        {lat: 46.3008270263672, lng: 24.8754367828369},
        {lat: 46.2994308471681, lng: 24.8697528839112},
        {lat: 46.3013610839844, lng: 24.8713779449462},
        {lat: 46.3036689758301, lng: 24.8711853027344},
        {lat: 46.3050041198731, lng: 24.8725585937501},
        {lat: 46.3068313598634, lng: 24.8699703216553},
        {lat: 46.307804107666, lng: 24.8670711517335},
        {lat: 46.3088111877442, lng: 24.8643283843994},
        {lat: 46.3112640380859, lng: 24.8635635375977},
        {lat: 46.3126602172852, lng: 24.867919921875},
        {lat: 46.3180198669435, lng: 24.8702697753907},
        {lat: 46.3197517395019, lng: 24.8730468749999},
        {lat: 46.3254737854003, lng: 24.8797187805176},
        {lat: 46.3258018493653, lng: 24.8747348785401},
        {lat: 46.3303756713867, lng: 24.8686122894287},
        {lat: 46.3391113281249, lng: 24.8709259033204},
        {lat: 46.3412322998047, lng: 24.8675041198731},
        {lat: 46.343132019043, lng: 24.8665580749512},
        {lat: 46.3463478088379, lng: 24.8648128509523},
        {lat: 46.3470306396485, lng: 24.8608646392823},
        {lat: 46.3473281860352, lng: 24.8567810058597},
        {lat: 46.3521995544434, lng: 24.8590850830079},
        {lat: 46.3559417724609, lng: 24.8570213317872},
        {lat: 46.3574523925781, lng: 24.8593006134034},
        {lat: 46.3564491271973, lng: 24.8644523620606},
        {lat: 46.3598747253418, lng: 24.8714733123779},
        {lat: 46.361629486084, lng: 24.8769702911377},
        {lat: 46.3635597229004, lng: 24.8820247650146},
        {lat: 46.3665466308595, lng: 24.8870716094971},
        {lat: 46.367733001709, lng: 24.883613586426},
        {lat: 46.373332977295, lng: 24.8838386535646},
        {lat: 46.3754234313966, lng: 24.8888626098634},
        {lat: 46.3792953491212, lng: 24.8856182098389},
        {lat: 46.3789710998536, lng: 24.881229400635},
        {lat: 46.3823852539064, lng: 24.8777084350587},
        {lat: 46.383934020996, lng: 24.8819522857667},
        {lat: 46.3838500976563, lng: 24.8913402557373},
        {lat: 46.3834457397462, lng: 24.8983478546145},
        {lat: 46.3877601623536, lng: 24.9024829864504},
        {lat: 46.3898963928224, lng: 24.9054126739503},
        {lat: 46.3909072875977, lng: 24.9101390838626},
        {lat: 46.3873252868652, lng: 24.9171276092529},
        {lat: 46.3886528015137, lng: 24.9204750061035},
        {lat: 46.3874778747559, lng: 24.9252662658691},
        {lat: 46.3836250305177, lng: 24.9303741455079},
        {lat: 46.3773460388185, lng: 24.9327220916748},
        {lat: 46.3777236938477, lng: 24.9441089630127},
        {lat: 46.3756484985352, lng: 24.946113586426},
        {lat: 46.3761749267578, lng: 24.9531345367432},
        {lat: 46.3797874450685, lng: 24.9701519012451},
        {lat: 46.3839645385742, lng: 24.9761848449707},
        {lat: 46.3848915100098, lng: 24.9795684814454},
        {lat: 46.3872909545899, lng: 24.9784202575685},
        {lat: 46.3905105590821, lng: 24.9766159057617},
        {lat: 46.3965072631837, lng: 24.9703636169436},
        {lat: 46.4010696411134, lng: 24.965093612671},
        {lat: 46.4039611816406, lng: 24.959396362305},
        {lat: 46.4040794372559, lng: 24.9546127319337},
        {lat: 46.4053192138672, lng: 24.9495658874512},
        {lat: 46.4051933288575, lng: 24.9437427520754},
        {lat: 46.4086837768556, lng: 24.9411449432373},
        {lat: 46.4098663330079, lng: 24.9377174377442},
        {lat: 46.4140663146973, lng: 24.9377880096436},
        {lat: 46.4192237854004, lng: 24.9373111724854},
        {lat: 46.4220008850098, lng: 24.9381847381593},
        {lat: 46.4245910644531, lng: 24.9406490325928},
        {lat: 46.4274482727051, lng: 24.9426059722901},
        {lat: 46.4298057556152, lng: 24.9460430145265},
        {lat: 46.4329261779785, lng: 24.950143814087},
        {lat: 46.4351615905762, lng: 24.9512290954592},
        {lat: 46.4394073486329, lng: 24.9510440826417},
        {lat: 46.4438438415528, lng: 24.9491024017333},
        {lat: 46.4455223083497, lng: 24.9565601348878},
        {lat: 46.4453582763671, lng: 24.9634189605713},
        {lat: 46.4470252990723, lng: 24.9653110504151},
        {lat: 46.446704864502, lng: 24.9689865112304},
        {lat: 46.4458351135253, lng: 24.9728755950928},
        {lat: 46.4452590942383, lng: 24.9777603149413},
        {lat: 46.4481277465821, lng: 24.9875469207764},
        {lat: 46.4518928527833, lng: 24.99054145813},
        {lat: 46.4569396972657, lng: 24.9919586181641},
        {lat: 46.4592895507812, lng: 24.9934368133545},
        {lat: 46.4628944396973, lng: 24.9933605194091},
        {lat: 46.4657630920411, lng: 24.990514755249},
        {lat: 46.4641723632813, lng: 24.9939117431641},
        {lat: 46.4654235839844, lng: 24.9960041046145},
        {lat: 46.4657936096192, lng: 24.9994640350341},
        {lat: 46.4643592834473, lng: 24.9972953796388},
        {lat: 46.4621925354005, lng: 24.9989585876465},
        {lat: 46.4588546752931, lng: 25.001745223999},
        {lat: 46.4621887207031, lng: 25.0085010528566},
        {lat: 46.4642066955566, lng: 25.0147743225098},
        {lat: 46.4643135070802, lng: 25.0195960998536},
        {lat: 46.4725685119629, lng: 25.0244655609131},
        {lat: 46.4773216247559, lng: 25.0234088897707},
        {lat: 46.4800872802734, lng: 25.0261497497559},
        {lat: 46.4816703796388, lng: 25.0198059082032},
        {lat: 46.4843750000001, lng: 25.0201778411866},
        {lat: 46.4851722717285, lng: 25.0185699462892},
        {lat: 46.4866867065431, lng: 25.0197639465335},
        {lat: 46.4888153076173, lng: 25.0175304412843},
        {lat: 46.4925270080568, lng: 25.0143547058105},
        {lat: 46.4919967651368, lng: 25.0123710632325},
        {lat: 46.4943046569824, lng: 25.0114631652832},
        {lat: 46.4956169128417, lng: 25.0048751831055},
        {lat: 46.495735168457, lng: 24.9964275360107},
        {lat: 46.4948997497559, lng: 24.9863128662111},
        {lat: 46.4996910095215, lng: 24.9888648986819},
        {lat: 46.5007209777833, lng: 24.9923419952393},
        {lat: 46.5066528320313, lng: 24.9984359741213},
        {lat: 46.5099105834962, lng: 25.0008907318116},
        {lat: 46.5102043151856, lng: 25.0053176879883},
        {lat: 46.5137825012207, lng: 25.0077991485596},
        {lat: 46.5178947448732, lng: 25.0111103057862},
        {lat: 46.5200691223145, lng: 25.0111751556397},
        {lat: 46.5266075134278, lng: 25.0175113677979},
        {lat: 46.5300140380861, lng: 25.0156860351564},
        {lat: 46.5341033935547, lng: 25.0193138122559},
        {lat: 46.5375556945802, lng: 25.0219879150392},
        {lat: 46.5412330627441, lng: 25.0258312225342},
        {lat: 46.5436706542969, lng: 25.0361270904542},
        {lat: 46.5466156005861, lng: 25.0404300689697},
        {lat: 46.5485420227051, lng: 25.0464382171631},
        {lat: 46.5521888732911, lng: 25.052755355835},
        {lat: 46.5540161132814, lng: 25.0616588592529},
        {lat: 46.5553588867189, lng: 25.0678997039796},
        {lat: 46.5575408935547, lng: 25.0725250244142},
        {lat: 46.562572479248, lng: 25.0758686065674},
        {lat: 46.5670890808107, lng: 25.0781688690186},
        {lat: 46.5704994201661, lng: 25.0776023864747},
        {lat: 46.571949005127, lng: 25.083595275879},
        {lat: 46.5743865966797, lng: 25.086597442627},
        {lat: 46.5773544311523, lng: 25.0953407287599},
        {lat: 46.5792236328126, lng: 25.1041870117189},
        {lat: 46.5825386047364, lng: 25.1058387756347},
        {lat: 46.5824089050293, lng: 25.1144218444824},
        {lat: 46.5816955566407, lng: 25.1183452606201},
        {lat: 46.5801010131837, lng: 25.1216697692871},
        {lat: 46.5797462463379, lng: 25.1240520477295},
        {lat: 46.5808410644531, lng: 25.1256828308105},
        {lat: 46.5786094665527, lng: 25.1309089660645},
        {lat: 46.5788192749025, lng: 25.1349239349365},
        {lat: 46.5779037475587, lng: 25.1396236419679},
        {lat: 46.5795707702637, lng: 25.1419849395753},
        {lat: 46.5786399841309, lng: 25.1477622985841},
        {lat: 46.5775146484376, lng: 25.1527290344239},
        {lat: 46.5798225402833, lng: 25.154577255249},
        {lat: 46.5849113464355, lng: 25.1550464630127},
        {lat: 46.5882263183594, lng: 25.1635246276856},
        {lat: 46.5919761657715, lng: 25.1677074432373},
        {lat: 46.5962409973145, lng: 25.1726799011231},
        {lat: 46.5984268188477, lng: 25.1761569976808},
        {lat: 46.599521636963, lng: 25.1801319122316},
        {lat: 46.6032905578614, lng: 25.181655883789},
        {lat: 46.6077117919922, lng: 25.1839828491211},
        {lat: 46.6123352050782, lng: 25.189193725586},
        {lat: 46.6144027709961, lng: 25.1893787384033},
        {lat: 46.6179809570312, lng: 25.1916027069094},
        {lat: 46.6209831237793, lng: 25.1946659088136},
        {lat: 46.6233673095703, lng: 25.1953849792481},
        {lat: 46.6268157958985, lng: 25.1965045928956},
        {lat: 46.6269874572755, lng: 25.2000923156738},
        {lat: 46.6255187988282, lng: 25.2168788909913},
        {lat: 46.6211891174317, lng: 25.2171459197998},
        {lat: 46.6198959350586, lng: 25.2182350158691},
        {lat: 46.6210899353028, lng: 25.220760345459},
        {lat: 46.6235008239747, lng: 25.2219066619873},
        {lat: 46.6267585754395, lng: 25.2201271057129},
        {lat: 46.6292839050294, lng: 25.221622467041},
        {lat: 46.6298713684083, lng: 25.2252578735352},
        {lat: 46.6281776428222, lng: 25.2256412506104},
        {lat: 46.6292839050294, lng: 25.2273521423342},
        {lat: 46.630241394043, lng: 25.2286128997803},
        {lat: 46.631374359131, lng: 25.2309856414796},
        {lat: 46.6332893371583, lng: 25.2325687408448},
        {lat: 46.6367607116699, lng: 25.2323055267335},
        {lat: 46.6381835937499, lng: 25.2276000976564},
        {lat: 46.6394271850587, lng: 25.224277496338},
        {lat: 46.6418838500977, lng: 25.2275276184081},
        {lat: 46.6467323303223, lng: 25.2353229522705},
        {lat: 46.6548080444336, lng: 25.2409229278565},
        {lat: 46.6643371582031, lng: 25.2401447296145},
        {lat: 46.6681175231934, lng: 25.2394390106201},
        {lat: 46.6718864440918, lng: 25.2460842132568},
        {lat: 46.674732208252, lng: 25.25545501709},
        {lat: 46.6710929870605, lng: 25.2645473480226},
        {lat: 46.670337677002, lng: 25.2728900909426},
        {lat: 46.6723365783692, lng: 25.2825508117676},
        {lat: 46.6828651428224, lng: 25.2905807495119},
        {lat: 46.6884574890137, lng: 25.2965126037598},
        {lat: 46.695140838623, lng: 25.2919311523438},
        {lat: 46.6996421813966, lng: 25.2876262664796},
        {lat: 46.7067337036133, lng: 25.284559249878},
        {lat: 46.7127113342285, lng: 25.2782478332521},
        {lat: 46.7167510986329, lng: 25.2716331481934},
        {lat: 46.7209434509278, lng: 25.2683010101319},
        {lat: 46.7268066406251, lng: 25.2624702453613},
        {lat: 46.7310485839845, lng: 25.2621974945069},
        {lat: 46.7356986999513, lng: 25.2654914855956},
        {lat: 46.7400627136231, lng: 25.2649726867676},
        {lat: 46.7461204528809, lng: 25.2624645233155},
        {lat: 46.7526283264161, lng: 25.26566696167},
        {lat: 46.7507667541505, lng: 25.2765140533449},
        {lat: 46.7522964477539, lng: 25.2882881164551},
        {lat: 46.7567138671876, lng: 25.2977981567384},
        {lat: 46.7601013183594, lng: 25.3015098571778},
        {lat: 46.7635536193849, lng: 25.30837059021},
        {lat: 46.7677459716797, lng: 25.3156127929688},
        {lat: 46.7730216979981, lng: 25.3200111389161},
        {lat: 46.778663635254, lng: 25.3166160583498},
        {lat: 46.7824058532715, lng: 25.317216873169},
        {lat: 46.7863731384278, lng: 25.3140373229981},
        {lat: 46.79008102417, lng: 25.3060626983642},
        {lat: 46.7951545715333, lng: 25.2980518341064},
        {lat: 46.7968330383301, lng: 25.2884368896486},
        {lat: 46.8020248413085, lng: 25.287805557251},
        {lat: 46.8085441589356, lng: 25.2838497161865},
        {lat: 46.8136634826661, lng: 25.2817134857179},
        {lat: 46.818874359131, lng: 25.2827148437501},
        {lat: 46.8268737792969, lng: 25.2831077575686},
        {lat: 46.8295974731446, lng: 25.2874279022218},
        {lat: 46.8350067138673, lng: 25.2851657867432},
        {lat: 46.835777282715, lng: 25.2783508300782},
        {lat: 46.8398590087891, lng: 25.2713680267335},
        {lat: 46.8420639038087, lng: 25.2636051177981},
        {lat: 46.8412055969239, lng: 25.2554073333741},
        {lat: 46.845314025879, lng: 25.2547454833984},
        {lat: 46.8494987487794, lng: 25.2553405761719},
        {lat: 46.8556900024414, lng: 25.2585830688477},
        {lat: 46.861427307129, lng: 25.26176071167},
        {lat: 46.8693656921387, lng: 25.2663688659669},
        {lat: 46.8786277770996, lng: 25.2687320709229},
        {lat: 46.8838844299317, lng: 25.2728080749514},
        {lat: 46.8882141113282, lng: 25.2713890075685},
        {lat: 46.8920783996583, lng: 25.2741546630861},
        {lat: 46.8972625732422, lng: 25.2786560058594},
        {lat: 46.8986244201661, lng: 25.2718601226807},
        {lat: 46.9034690856934, lng: 25.2671432495117},
        {lat: 46.9087448120118, lng: 25.2660942077637},
        {lat: 46.9128036499025, lng: 25.2638225555419},
        {lat: 46.9236068725587, lng: 25.2692852020264},
        {lat: 46.9286842346192, lng: 25.2715950012206},
        {lat: 46.9329414367677, lng: 25.2722663879395},
        {lat: 46.9375305175782, lng: 25.2723045349122},
        {lat: 46.9426193237305, lng: 25.2731208801269},
        {lat: 46.9482307434081, lng: 25.2742671966554},
        {lat: 46.9511032104493, lng: 25.2784595489502},
        {lat: 46.9537162780763, lng: 25.2851638793946},
        {lat: 46.9582290649415, lng: 25.2826347351075},
        {lat: 46.9659996032715, lng: 25.2853183746338},
        {lat: 46.9692192077637, lng: 25.2897853851318},
        {lat: 46.9752349853516, lng: 25.2899188995361},
        {lat: 46.9781951904297, lng: 25.2848491668701},
        {lat: 46.980453491211, lng: 25.2909984588624},
        {lat: 46.984848022461, lng: 25.2910308837891},
        {lat: 46.9889907836914, lng: 25.290008544922},
        {lat: 46.9933242797853, lng: 25.2905063629151},
        {lat: 46.996955871582, lng: 25.2856826782229},
        {lat: 46.9993133544922, lng: 25.2778873443604},
        {lat: 47.0024185180665, lng: 25.2765254974366},
        {lat: 47.0097389221192, lng: 25.2680740356447},
        {lat: 47.0153045654297, lng: 25.2708606719971},
        {lat: 47.023250579834, lng: 25.2709007263186},
        {lat: 47.0295791625976, lng: 25.2721138000489},
        {lat: 47.0345954895021, lng: 25.2677917480469},
        {lat: 47.0376739501954, lng: 25.264720916748},
        {lat: 47.0398292541504, lng: 25.2596416473389},
        {lat: 47.0435485839844, lng: 25.2533378601074},
        {lat: 47.0473747253419, lng: 25.2472686767578},
        {lat: 47.055347442627, lng: 25.2382335662843},
        {lat: 47.0618019104004, lng: 25.232719421387},
        {lat: 47.0736732482911, lng: 25.2317447662354},
        {lat: 47.0831222534181, lng: 25.2364597320558},
        {lat: 47.0919151306152, lng: 25.2412281036379},
        {lat: 47.0981903076173, lng: 25.2483158111572},
        {lat: 47.1039848327637, lng: 25.2664890289307},
        {lat: 47.1039466857911, lng: 25.2809562683105},
        {lat: 47.1093101501465, lng: 25.2891197204591},
        {lat: 47.1177139282227, lng: 25.2980518341064},
        {lat: 47.1226959228516, lng: 25.2973728179932},
        {lat: 47.1274452209473, lng: 25.2924041748047},
        {lat: 47.1337051391603, lng: 25.28888130188},
        {lat: 47.139591217041, lng: 25.2927074432374},
        {lat: 47.1454887390137, lng: 25.2960224151611},
        {lat: 47.1535148620605, lng: 25.295467376709},
        {lat: 47.1576499938964, lng: 25.2982368469241},
        {lat: 47.1656913757324, lng: 25.3073120117189},
        {lat: 47.1651916503906, lng: 25.3209171295167},
        {lat: 47.1679992675782, lng: 25.3302135467529},
        {lat: 47.1737251281738, lng: 25.348711013794},
        {lat: 47.1789703369141, lng: 25.3580131530762},
        {lat: 47.1782646179199, lng: 25.3661975860596},
        {lat: 47.1756439208986, lng: 25.3746738433841},
        {lat: 47.1790885925294, lng: 25.3850078582766},
        {lat: 47.1812438964844, lng: 25.3934440612794},
        {lat: 47.1786956787111, lng: 25.4054069519044},
        {lat: 47.1836242675782, lng: 25.4220352172852},
    ];

    // create the poligon object for Harghita County border
    var HR_county_border = new google.maps.Polygon({
        path: HR_county_coordinates,
        geodesic: true,
        strokeColor: '#999',
        strokeOpacity: 0.3,
        strokeWeight: 3,
    });

    // draw the border
    HR_county_border.setMap(map);

    
    // Filter the dataTable in order to create an array witch contains the unique LatLng's
    // Based on this array, the locations will be drawn to the Google Map
    var uniqueLatLng = table.column(0).data().unique();
    
    // loop through the array
    for (var i = 0; i < uniqueLatLng.length; i++) {
        
        var most_recent_date = new Date('December 31, 1900 23:59:59');

        // Filter the table for those rows which have `uniqueLatLng` in the first column
        table
            .rows(function (rowIdx) {
                return table.cell( rowIdx, 0 ).data() === uniqueLatLng[i] ? true : false;
            })
            .every(function (rowIdx){
                var water_check_date = this.cell(rowIdx, 3).data();
                var yyyy = Number(water_check_date.substring(6,10));
                var mm   = Number(water_check_date.substring(3, 5));
                var dd   = Number(water_check_date.substring(0, 2));
                var current_row_date = new Date(yyyy, mm - 1, dd);

                if (current_row_date > most_recent_date) { 
                    most_recent_date = current_row_date;
                    row_to_display = rowIdx;
                }
            });

        // the latLng in the table is in one single cell & in string format
        // so it has to be converted to a latLng object
        var comma  = uniqueLatLng[i].search(',');
        var lat    = Number(uniqueLatLng[i].substring(0,comma));
        var lng    = Number(uniqueLatLng[i].substring(comma+1,uniqueLatLng[i].length));
        var latLng = { lat: lat, lng: lng };

        // construct the infoWindow content
        var iw_localitate = table.cell(row_to_display, 1).data();
        var iw_zona       = table.cell(row_to_display, 2).data();
        var iw_data_proba = table.cell(row_to_display, 3).data();
        var iw_chimici    = evaluateResult(row_to_display, 4, 'Parametri chimici');
        var iw_clor       = evaluateResult(row_to_display, 5, 'Clor rezidual liber');
        var iw_bacter     = evaluateResult(row_to_display, 6, 'Parametri bacteorologici');
        var markerIcon;

        var iw_content = '<div>' + 
            '<p> Localitate:<strong style="color:#158cba";> ' + iw_localitate + '</strong></p>'      +
            '<p> Data probă apă:<strong style="color:#158cba";>  ' + iw_data_proba + '</strong></p>' +
            '<p>' + iw_chimici.text + '</p>' +
            '<p>' + iw_clor.text    + '</p>' + 
            '<p>' + iw_bacter.text  + '</p>' +
            '<p>Pentru mai mute informaţii filtraţi tabelul după Zona de aprovizionare: <strong style="color:#158cba";> ' + 
            iw_zona + '</strong></p>' +
        '</div>';

        if (iw_chimici.corresponds & iw_clor.corresponds & iw_bacter.corresponds ) {
            markerIcon = static_url + 'images/waterdrop-blue.png';
        } else {
            markerIcon = static_url + 'images/waterdrop-red.png';
        }

        createMarker(latLng, markerIcon, iw_localitate, iw_content);
    }

    // display legend on the map
    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(document.getElementById('legend'));

    var icons = {
        corespunde: {
            name: 'Corespunde',
            icon: static_url + 'images/waterdrop-blue.png',
        },
        nu_corespunde: {
            name: 'Nu corespunde',
            icon: static_url + 'images/waterdrop-red.png',
        }
    };

    var legend = document.getElementById('legend');

    for (var key in icons) {
        var type = icons[key];
        var name = type.name;
        var icon = type.icon;
        var div = document.createElement('div');
        div.style = 'margin-bottom: 3px';
        div.innerHTML = '<img style="width: 20px; height: auto" src="' + icon + '"> ' + name;
        legend.appendChild(div);
    }

    // center/align Google Maps in a div with a variable width
    $(window).on('resize', function() {
        var currCenter = map.getCenter();
        google.maps.event.trigger(map, 'resize');
        map.setCenter(currCenter);
    });
}


function evaluateResult(table_row, table_col, paramName ) {

    // **************************************************
    // Evaluates the cell value identified by 'table_row' and 'table_col'
    //
    // Returns: an object with two propierties
    //   - text: will be part of the infoWindow
    //   - corresponds: boolean
    //         
    // Parameters:
    //   - table_row  : row of the cell
    //   - table cell : column of the cell
    //   - paramName  : the name of the parameter that will be included in the response
    // **************************************************
    
    // contains the 'data' of the table cell
    var paramData = table.cell(table_row, table_col).data().trim().toUpperCase();
    var parName = paramName.trim().toUpperCase();
    
    // object used for temporary calculation
    var result = {};

    if (paramData == 'NU CORESPUNDE') {
        result.icon = 'glyphicon-thumbs-down';
        result.corresponds = false;
        
        switch (parName) {
           
        case 'PARAMETRI CHIMICI': 
            result.color = 'red';
            break;
        case 'CLOR REZIDUAL LIBER':
            result.color = '#e3c91a'; // yellow
            break;
        case 'PARAMETRI BACTEOROLOGICI':
            result.color = 'purple';
            break;
        default:
            result.color = 'orange';
            console.log('Something went wrong in the evaluateResult function: color could not be set!');
        }
    } else {
        result.icon = 'glyphicon-thumbs-up';
        result.corresponds = true;
        result.color = '#158cba'; // blue;
    }

    // contruct the return value
    var s1 = `<span style='color:${result.color}' class='glyphicon ${result.icon}'></span> `;
    var s2 = `${paramName}:` + (result.corresponds ? ' corespunde' : ' nu corespunde'); 
    var text = s1 + s2;

    return {
        'text': text,
        'corresponds': result.corresponds
    } ;
}



function createMarker(latlng, icon, title, iw_content) {

    // draw the marker on map
    var marker = new google.maps.Marker({
        position: latlng,
        title: title,
        map: map,
        icon: icon,
    });

    // add click event listener to marker
    google.maps.event.addListener(marker, 'click', function () {
        infoWindow.setContent(iw_content);
        infoWindow.open(map, marker);
    });

}


$(document).ready(function() {

    // select the proper language
    // https://datatables.net/manual/i18n
    var path_to_lang;

    switch (current_language) {
    case 'ro':
        path_to_lang = '//cdn.datatables.net/plug-ins/1.10.16/i18n/Romanian.json';
        break;
    case 'hu':
        path_to_lang = '//cdn.datatables.net/plug-ins/1.10.16/i18n/Hungarian.json';
        break;
    default:
        path_to_lang = '//cdn.datatables.net/plug-ins/1.10.16/i18n/English.json';
        break;
    }


    // initialize the dataTable
    if ($.fn.dataTable.isDataTable('.table-smart-special')) {
        // table has been initialized already
        table = $('.table-smart-special').DataTable();
    } else {
        // table is initializing now
        table = $('.table-smart-special').DataTable({
            'columnDefs': [
                // { 'targets': 0, 'visible': false }, // Hide the first column with columnDefs
                { 'targets': [2], 'searchable': true },
                { 'targets': '_all', 'searchable': false },
                { 'targets': [0,1,2,3,4,5,6], 'className': 'success' },
            ],
            'pagingType': 'numbers',
            'orderData': [ 0, 4 ], // sort on LatLng, then on Date
            'pageLength': 15,
            'language': {
                'url' : path_to_lang,
            },
        });
    }
});
